import { Box, Chip, Stack, Typography } from '@mui/material';
import type { OfferFormData } from '../offers/offerForm';
import { formatDiscount, formatPeriod } from './formatters';

const chipSx = (bgcolor: string, color: string) => ({ fontSize: '0.68rem', height: 20, bgcolor, color });

function OfferSummaryItem({ offer }: { offer: OfferFormData }) {
  const period = formatPeriod(offer.startValidityDate, offer.endValidityDate);
  const discount = formatDiscount(offer);

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 1.5, backgroundColor: 'grey.50' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
        <Typography variant="body2" fontWeight={700} sx={{ flex: 1 }}>
          {offer.title}
        </Typography>
        {offer.offerNumber && (
          <Chip
            label={offer.offerNumber}
            size="small"
            sx={{ fontSize: '0.65rem', height: 18, ml: 1, fontFamily: theme => theme.typography.fontFamilyMono, bgcolor: 'badge.blue.bg', color: 'badge.blue.fg' }}
          />
        )}
      </Box>
      {offer.description && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
          {offer.description}
        </Typography>
      )}
      <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', mt: 0.5 }}>
        {discount && <Chip label={discount} size="small" sx={chipSx('badge.green.bg', 'badge.green.fg')} />}
        {period && <Chip label={period} size="small" sx={chipSx('badge.purple.bg', 'badge.purple.fg')} />}
        {offer.nbMaxEdit && <Chip label={`Max ${offer.nbMaxEdit} éd.`} size="small" sx={chipSx('badge.orange.bg', 'badge.orange.fg')} />}
        {offer.nbMaxUse && <Chip label={`Max ${offer.nbMaxUse} util.`} size="small" sx={chipSx('badge.pink.bg', 'badge.pink.fg')} />}
      </Box>
    </Box>
  );
}

function OfferSummaryList({ offers }: { offers: OfferFormData[] }) {
  return (
    <Stack spacing={1}>
      {offers.map(offer => <OfferSummaryItem key={offer.id} offer={offer} />)}
    </Stack>
  );
}

export default OfferSummaryList;
